const loadCoverVideo = () => {
    if(document.querySelector('.ume-cover-video')){
        let allVideos = document.querySelectorAll('.ume-cover-video');
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        allVideos.forEach( v =>{
            if(vw > 780){
                let s = v.getAttribute('data-src');
                v.src = s;
            }else{
                v.src = '';
            }

        })
    }
}
export default loadCoverVideo;